import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';

import { AppsServiceModule } from 'services/data/apps.service';
import { ExtensionServiceModule } from 'services/data/extension.service';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { SegmentServiceModule } from 'services/tracking/segment/segment.service';
import { VlnBackImageModule } from 'directives/vlnBackImage.directive';
import { MobileAnalyticsServiceModule } from 'services/tracking/mobileApps/mobileAnalytics.service';
import { StorefrontCacheServiceModule } from 'services/utilities/storefrontCache.service';
import { LaunchChangePlanServiceModule } from 'components/changePlan/launchChangePlan.service';

import template from './appExtensionConfirmInstall.html';
import './appExtensionConfirmInstall.scss';

export const AppExtensionConfirmInstallModule = angular
    .module('app.components.appExtensionPreview.appExtensionConfirmInstall', [
        'ngMaterial',
        uiRouter,
        ngTranslate,
        AppsServiceModule,
        ExtensionServiceModule,
        AuthTokenServiceModule,
        VlnBackImageModule,
        MobileAnalyticsServiceModule,
        SegmentServiceModule,
        StorefrontCacheServiceModule,
        LaunchChangePlanServiceModule
    ]).component('appExtensionConfirmInstall', {
        template,
        bindings: {
            app: '<',
            appType: '@',
            isInstalled: '<'
        },
        controller: class AppExtensionConfirmInstall {
            constructor(
                $scope,
                $mdDialog,
                appsService,
                extensionService,
                $state,
                $translate,
                $window,
                authTokenService,
                segmentService,
                mobileAnalyticsService,
                storefrontCacheService,
                launchChangePlanService
            ) {
                'ngInject';

                assign(this, {
                    $scope,
                    $mdDialog,
                    appsService,
                    extensionService,
                    $state,
                    $translate,
                    $window,
                    authTokenService,
                    mobileAnalyticsService,
                    storefrontCacheService,
                    launchChangePlanService,
                    isLoading: false,
                    translationsArray: [
                        'APPSTORE.CONFIRMINSTALLFREEAPPBLURB',
                        'APPSTORE.CONFIRMINSTALLFREEAPPWITHPLUSBLURB',
                        'APPSTORE.CONFIRMINSTALLFREEEXTNBLURB',
                        'APPSTORE.CONFIRMINSTALLFREEEXTNWITHPLUSBLURB',
                        'APPSTORE.CONFIRM_UNINSTALL_APP_BLURB'
                    ],
                    blurbText: '',
                    installing: false,
                    installError: null,
                    gtmid: `admin_${$state.current.name}`,
                    segmentService
                });
            }

            $onInit() {
                this.$translate(this.translationsArray, {
                    APP: this.app.title
                }).then((translations) => {
                    this.setBlurbText(translations);
                });
            }

            setBlurbText(translationsHash) {
                if (this.isApplication()) {
                    if (this.isInstalled) {
                        this.blurbText = translationsHash['APPSTORE.CONFIRM_UNINSTALL_APP_BLURB'];
                    } else if (this.app.planLevel === 'Lite') {
                        this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEAPPBLURB'];
                    } else {
                        this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEAPPWITHPLUSBLURB'];
                    }
                } else {
                    if (this.app.planLevel === 'Lite') {
                        this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEEXTNBLURB'];
                    } else {
                        this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEEXTNWITHPLUSBLURB'];
                    }
                }
            }

            closeConfirmInstall() {
                return this.$mdDialog.cancel('cancel');
            }

            isApplication() {
                return this.appType === 'application';
            }

            isExtension() {
                return this.appType === 'extension';
            }

            sendInstalledEvent(isApp = true, name = '') {
                this.authTokenService.getTenantId().then((tenantID) => {
                    const eventPayload = isApp ?
                        {
                            event: 'InstalledApp',
                            appName: name,
                            tenantID
                        } : {
                            event: 'InstalledExtension',
                            extensionName: name,
                            tenantID
                        };
                    this.$window.dataLayer.push(eventPayload);
                });
            }

            sendUninstalledEvent(isApp = true, name = '') {
                this.authTokenService.getTenantId().then((tenantID) => {
                    const eventPayload = isApp ?
                        {
                            event: 'UninstalledApp',
                            appName: name,
                            tenantID
                        } : {
                            event: 'UninstalledExtension',
                            extensionName: name,
                            tenantID
                        };
                    this.$window.dataLayer.push(eventPayload);
                });
            }

            install() {
                this.installing = true;
                if (this.isApplication()) {
                    this.appsService.installApp(this.app).then(() => {
                        this.onAppActionFinished('apps:newInstalled', 'App Store: Installed');
                    }).catch(() => {
                        this.installError = 'This app is not available to your current plan.';
                    });
                } else {
                    this.extensionService.installExtension({ extensionId: this.app.id }).then(() => {
                        this.onAppActionFinished('apps:newInstalled', 'App Store: Installed');
                    });
                }
            }

            uninstall() {
                this.installing = true;
                const APP_UNINSTALLED = true;
                this.appsService.uninstallApp(this.app).then(() => {
                    this.onAppActionFinished('apps:uninstalled', 'App Store: Uninstalled', APP_UNINSTALLED);
                }).catch(() => {
                    this.installError = 'Something went wrong while uninstalling. Please refresh and try again.';
                });
            }

            openPlans(ev) {
                this.closeConfirmInstall().then(() => {
                    this.launchChangePlanService.openModal(ev, null, true);
                });
            }

            onAppActionFinished(event, mobileEvent, appUninstalled = false) {
                this.$scope.$emit(event, this.app);
                this.installing = false;

                if (appUninstalled) {
                    this.sendUninstalledEvent(this.isApplication(), this.app.title);
                } else {
                    this.sendInstalledEvent(this.isApplication(), this.app.title);
                }

                this.mobileAnalyticsService.trackEvent(mobileEvent, {});
                this.storefrontCacheService.refresh('appstore');
                this.$mdDialog.hide({ sku: this.app.sku, event });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/appExtensionPreview/appExtensionConfirmInstall.component.js